import dashboard from './dashboard'
import casl from './casl'
import progressBar from './progress-bar'
import errors from './errors'
import draggable from './draggable'
import other from './other'
import nfl from './nfl'

export default {
  ...dashboard,
  ...casl,
  ...progressBar,
  ...errors,
  ...draggable,
  ...other,
  ...nfl
}



// WEBPACK FOOTER //
// ./src/store/mutations/index.js